module.exports = __webpack_public_path__ + "static/media/slajd-3.499c14bd.jpg";